import { useCallback, useContext, useEffect, useState } from "react";
import "./QaListPage.scss";
import * as orderService from "../../Services/Http/OrderService";
import { OrderList } from "../../Models/OrderList";
import { ApiError } from "../../Models/ApiError";
import { ChangeStatusRequest } from "../../Models/ChangeStatusRequest";
import { TransHeaderResponse } from "../../Models/TransHeaderResponse";
import { Order } from "../../Models/Order";
import OrderListComponent from "../../Components/OrderListComponent/OrderListComponent";
import { dataContext } from "../../Context/contextProvider";

interface Props {}

const successSound = new Audio();
successSound.src = "/assets/sounds/success.mp3";
successSound.load();

const errorSound = new Audio();
errorSound.src = "/assets/sounds/error.mp3";
errorSound.load();

const QaListPage = (props: Props) => {
  const [orders, setOrders] = useState<Order[]>([]);
  const dataStore = useContext(dataContext);

  const bindGrid = useCallback(() => {
    orderService
      .getExistingOrdersForQaAPI(dataStore.serverUrl || "", dataStore.dbKey || "")
      .then((resp: OrderList) => {
        if (resp) {
          setOrders([...resp.result!]);
        } else {
          setOrders([]);
        }
      })
      .catch((err: ApiError) => {
        //toast.error(err.message); //error already handled in error handler
      });
  }, [dataStore.dbKey, dataStore.serverUrl]);

  useEffect(() => {
    bindGrid();
  }, [bindGrid]);

  const handleSetModalResult = (changeStatusRequest: ChangeStatusRequest): Promise<TransHeaderResponse> => {
    return new Promise<TransHeaderResponse>((resolve, reject) => {
      orderService
        .setOrderQAStatusAPI(changeStatusRequest, dataStore.serverUrl || "", dataStore.dbKey || "")
        .then((resp: TransHeaderResponse) => {
          bindGrid();
          resolve(resp);
        })
        .catch((err: ApiError) => {
          bindGrid();
          reject(err);
        });
    });
  };
  return <OrderListComponent orderArr={orders} modalTitle="Has the order passed QA?" onSetModalResult={handleSetModalResult} />;
};

export default QaListPage;
